/**
 * @fileoverview Logic for the component that is rendered into table, contains mission actions
 */
import React from 'react'
import { withRouter } from 'react-router-dom'
import { authorization } from '../../Module/Auth/Auth'
import { STATUS_BOOKED } from '../../shared/constants'
import { LinkView } from '../Link/View'
import { ButtonDeleteInline } from '../Buttons/ButtonDeleteInline'

/**
 * Component that used as controls for mission table row
 * @param {number} props.missionId Mission's id
 * @param {number} props.statusNumber Mission's status
 * @param {function} props.deleteMissions Function for mission deletion
 * @param {object} props.match Router's match object, used for link generation
 *
 * @returns {JSX.Element}
 */
const MissionTableActions = withRouter(
  ({ missionId, statusNumber, onDelete, match }) => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <LinkView to={`${match.url}/${missionId}`} />
        {(authorization.isAdmin() || authorization.isCityManager()) &&
          statusNumber < STATUS_BOOKED && (
            <ButtonDeleteInline
              onClickHandler={e => {
                e.preventDefault()
                e.stopPropagation()
                return onDelete(missionId)
              }}
            />
          )}
      </div>
    )
  },
)

export default MissionTableActions



// WEBPACK FOOTER //
// ./src/Components/MissionTableActions/MissionTableActions.js